module.exports = __webpack_public_path__ + "media/images/spinner-281716bef82e966802be84a22cb862ee.png";